import { render } from "./EmergencyNotice.vue?vue&type=template&id=f594c58c&scoped=true"
import script from "./EmergencyNotice.vue?vue&type=script&lang=js"
export * from "./EmergencyNotice.vue?vue&type=script&lang=js"

import "./EmergencyNotice.vue?vue&type=style&index=0&id=f594c58c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f594c58c"]])

export default __exports__